/* Mostashop — page « Bons Plans & Astuces » : ouverture du chat Tidio depuis le bouton CTA.
   L'animation d'entrée au défilement des cartes .card est déjà gérée par initReveal()
   dans mostashop.js (chaque carte y est déjà observée automatiquement). */
(function () {
  'use strict';

  function openTidioChat() {
    if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
      window.tidioChatApi.open();
      return true;
    }
    return false;
  }

  function initBonsPlansCta() {
    var btn = document.querySelector('[data-bp-cta-tidio]');
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    var fallback = document.querySelector('[data-bp-cta-fallback]');

    btn.addEventListener('click', function () {
      if (openTidioChat()) {
        if (fallback) fallback.hidden = true;
        return;
      }
      if (fallback) fallback.hidden = false;
      var tries = 0;
      var retry = setInterval(function () {
        tries++;
        if (openTidioChat()) {
          clearInterval(retry);
          if (fallback) fallback.hidden = true;
        } else if (tries >= 6) {
          clearInterval(retry);
        }
      }, 500);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBonsPlansCta);
  else initBonsPlansCta();

  document.addEventListener('shopify:section:load', initBonsPlansCta);
})();
